import { render, staticRenderFns } from "./AnswerFormula.vue?vue&type=template&id=6cfca867&scoped=true&lang=pug&"
import script from "./AnswerFormula.vue?vue&type=script&lang=ts&"
export * from "./AnswerFormula.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerFormula.vue?vue&type=style&index=0&id=6cfca867&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfca867",
  null
  
)

export default component.exports